import React, {useMemo} from "react";
import {AsideMenuList} from "./AsideMenuList";
import {AsideMenuListAdmin} from "./AsideMenuListAdmin";

import {useHtmlClassService} from "../../../_core/MetronicLayout";

import { useSelector, shallowEqual } from "react-redux";

export function AsideMenu({disableScroll}) {

  const { isAuthorized, isAdmin, isSimulating, auth } = useSelector(
    ({ auth }) => ({
      auth,
      isAuthorized: auth.user != null,
      isAdmin: auth.user != null && auth.user.roles.includes(0),
      isSimulating: auth.user != null && (auth.user.roles.includes(0) && auth.user.client.id != undefined)
    }),
    shallowEqual
  );

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true),
      auth: auth.user
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
      >
        {isAdmin && !isSimulating
          ? <AsideMenuListAdmin layoutProps={layoutProps} />
          : <AsideMenuList layoutProps={layoutProps} />
        }
      </div>
      {/* end::Menu Container */}
    </>
  );
}
